import React, { useEffect } from 'react';
import Chart from 'react-apexcharts';

import { dominioDemandaCirurgica } from '../../../../config/database';

export default function ModalQuantidadeEletivoVsUrgencia(props) {
  const [options, setOptions] = React.useState({
    series: [],
    labels: [],
    dataLabels: {
      enabled: true,
    },
    legend: {
      show: true,
      position: 'top',
      horizontalAlign: 'center',
    },
    responsive: [
      {
        breakpoint: 576,
        options: {
          chart: {
            height: '300px',
            width: '300px',
          },
        },
      },

      {
        breakpoint: 768,
        options: {
          chart: {
            height: '500px',
            width: '500px',
          },
        },
      },

      {
        breakpoint: 992,
        options: {
          chart: {
            height: '600px',
            width: '600px',
          },
        },
      },
    ],
  });

  const { equipes, centrosCirurgicos, dataInicio, dataFim, eOnco } = props;

  const updateCharts = () => {
    const idsEquipes = equipes.map(equipe => {
      return equipe.id;
    });

    const idsCentrosCirurgicos = centrosCirurgicos.map(centroCirurgico => {
      return centroCirurgico.id;
    });

    const dados = {
      filtros: {
        equipes: idsEquipes?.length > 0 ? idsEquipes.join() : null,
        centrosCirurgicos: idsCentrosCirurgicos?.length > 0 ? idsCentrosCirurgicos.join() : null,
        dataInicio: new Date(dataInicio),
        dataFim: new Date(dataFim),
        eOnco,
      },
    };

    dominioDemandaCirurgica.post(`/api/listarQuantidadeEletivoVsUrgencia`, dados).then(response => {
      const config = {
        series: [],
        labels: [],
        dataLabels: {
          enabled: true,
        },
        legend: {},
      };
      const series = response.data.map(dado => {
        return dado.quantidade;
      });
      const labels = response.data.map(dado => {
        return dado.descricao;
      });
      config.series = series;
      config.labels = labels;
      setOptions(config);
    });
  };

  useEffect(() => {
    updateCharts();
  }, []);

  return <Chart options={options} series={options.series} type="pie" width="70%" />;
}
